import { Box, Color, ResponsiveValue, withCitrusTheme } from '@gousto-internal/citrus-react';
import { keyframes } from '@emotion/react';

const shimmerKeyframes = keyframes(`
      0% {
          background-position: 200% 0;
      }
      50% {
          background-position: 0% 0;
      }
      100% {
          background-position: 0% 0;
      }
  `);

const SkeletonFill = withCitrusTheme(Box, (theme) => {
  return {
    ...theme.radius(1.5),
    background: `linear-gradient(90deg, ${theme.color(Color.ColdGrey_50)} 65%, #F2F3F4 75%, ${theme.color(Color.ColdGrey_50)} 90%)`,
    animation: `${shimmerKeyframes} 2s ease-in-out infinite`,
    backgroundSize: '200% 100%',
    animationDelay: '100ms',
  };
});

export function LoadingSkeleton({
  width,
  height,
}: {
  width: ResponsiveValue<string>;
  height?: ResponsiveValue<string>;
}) {
  return (
    <SkeletonFill width={width} height={height}>
      &zwnj;
    </SkeletonFill>
  );
}
